// extracted by mini-css-extract-plugin
export default {"cancelButton":"cancel_button-module___cancelButton___c3c329b2"};